import { DropDown, FileUpload } from '@/components/Exporter'
import { useTranslation } from 'react-i18next'
import { GetCatgoryLookup, GetSubCatgoryLookup } from '@/api/endpoints'
import { SERVICES_TYPES } from '@/data/Constant'
import { Icon } from '@iconify/react/dist/iconify.js'
import { useMemo } from 'react'

const GetMedicalCategories = () => GetCatgoryLookup(SERVICES_TYPES.Medical)

const SpecialitiesDocs = ({ formHandler ,data}) => {

    const { formValues } = formHandler
    const { t } = useTranslation()

    const isSubCategoryAllowedToFetch = useMemo(() => !!formValues?.specialty?.value?.value, [formValues?.specialty])


    return (
        <div className="form-section">
            <div className="section-header">
                <Icon icon="mdi:certificate" className="section-icon" />
                <h2>{t('specialization-documents')}</h2>
            </div>
            <div className="row">

                <DropDown defaultValue={data?.specialtyId} label={'specialty'} isMulti={false} endPoint={GetMedicalCategories} formHandler={formHandler} />

                <DropDown label={'department'} isMulti={false}
                    params={['specialty']} isAllowedToFetch={isSubCategoryAllowedToFetch}
                    defaultValue={data?.majorSpecialtyId} endPoint={GetSubCatgoryLookup} formHandler={formHandler} />
            </div>


            {/*
<FileUpload
            label={t('documents-cv-certifications')}
            accept="image/*"
            value={documents}
            multiple={true}
            setValue={handleDocumentsChange}
            isRequired={false}
            />
            */}
        </div>
    )
}

export default SpecialitiesDocs